import { __decorate } from "tslib";
import { BasePlugin, Plugin } from "@fastoche/core";
import Vue from "vue";
import { GlobalApplicationContext } from "./GlobalApplicationContext";
let VuePlugin = class VuePlugin extends BasePlugin {
    install(ctx, config) {
        this.rootComponentOptions = config.options;
    }
    start(ctx) {
        this.rootComponent = new Vue(this.rootComponentOptions);
        GlobalApplicationContext.default.vue = this.rootComponent;
    }
};
VuePlugin = __decorate([
    Plugin()
], VuePlugin);
export { VuePlugin };
//# sourceMappingURL=VuePlugin.js.map